import type { ReactNode } from 'react'

import { ConfirmDialog } from '@/components/molecules/confirm-dialog.molecule'
import type { OrganizationInvitation } from '@/components/org-settings/members/members.interface'

interface RevokeInvitationDialogProps {
  invitation: OrganizationInvitation | null
  onClose: () => void
  onConfirm: () => Promise<void>
}

export const RevokeInvitationDialog: React.FC<RevokeInvitationDialogProps> = ({
  invitation,
  onClose,
  onConfirm,
}): ReactNode => (
  <ConfirmDialog
    isOpen={invitation !== null}
    onOpenChange={(isOpen) => !isOpen && onClose()}
    title="Revoke Invitation"
    description={`Are you sure you want to revoke the invitation sent to ${invitation?.emailAddress ?? 'this email'}?`}
    confirmLabel="Revoke"
    onConfirm={onConfirm}
    variant="destructive"
  />
)

RevokeInvitationDialog.displayName = 'RevokeInvitationDialog'
